import AWS from 'aws-sdk/global'
import defaultValues from '../lib/defaultValues.js'
import HomAptCognito from '../lib/cognitoLogin.js'

const state = {
  email: defaultValues.email,
  phoneNumber: defaultValues.phoneNumber,
  MFA: defaultValues.MFA,
  businessName: defaultValues.businessName,
  address: defaultValues.address,
  addressTwo: defaultValues.addressTwo,
  city: defaultValues.city,
  state: defaultValues.state,
  zip: defaultValues.zip,
  businessPhone: defaultValues.businessPhone,
  website: defaultValues.website,
  companyInfo: defaultValues.companyInfo,
  companyInfoTwo: defaultValues.companyInfoTwo,
  areasServiced: JSON.parse(JSON.stringify(defaultValues.areasServiced)),
  alteredForms: JSON.parse(JSON.stringify(defaultValues.alteredForms)),
  adminFirstName: defaultValues.adminFirstName,
  adminLastName: defaultValues.adminLastName,
  adminEmail: defaultValues.adminEmail,
  adminPhone: defaultValues.adminPhone,
  qcFirstName: defaultValues.qcFirstName,
  qcLastName: defaultValues.qcLastName,
  qcEmail: defaultValues.qcEmail,
  qcPhone: defaultValues.qcPhone,
  csFirstName: defaultValues.csFirstName,
  csLastName: defaultValues.csLastName,
  csEmail: defaultValues.csEmail,
  csPhone: defaultValues.csPhone,
  salesEmail: defaultValues.salesEmail,
  displayName: defaultValues.displayName,
  salesPhoneNumber: defaultValues.salesPhoneNumber,
  insuranceAmount: defaultValues.insuranceAmount,
  licenseNumber: defaultValues.licenseNumber,
  costLevel: defaultValues.costLevel,
  availabilityLevel: defaultValues.availabilityLevel,
  times: JSON.parse(JSON.stringify(defaultValues.times)),
  emergencies: defaultValues.emergencies,
  selectedServices: JSON.parse(JSON.stringify(defaultValues.selectedServices)),
  images: JSON.parse(JSON.stringify(defaultValues.images)),
  profileImage: defaultValues.profileImage,
  bannerImage: defaultValues.bannerImage,
  ssn: defaultValues.ssn,
  serviceType: defaultValues.serviceType,
  yearEstablished: defaultValues.yearEstablished,
  languagesSpoken: defaultValues.languagesSpoken,
  hideAddress: defaultValues.hideAddress,
  allowSendTexts: defaultValues.allowSendTexts,
  enableQuoteRequest: defaultValues.enableQuoteRequest,
  hideYears: defaultValues.hideYears,
  businessId: defaultValues.businessId,
  blockList: defaultValues.blockList,
  serviceAreaCoords: JSON.parse(JSON.stringify(defaultValues.serviceAreaCoords)),
  couponPaymentOverdue: defaultValues.couponPaymentOverdue,
  paymentFailureNotification: defaultValues.paymentFailureNotification,
  specialties: JSON.parse(JSON.stringify(defaultValues.specialties)),
  hasAdvertisingPlan: defaultValues.hasAdvertisingPlan
}

const getters = {
  getHasAdvertisingPlan: (state) => {
    return state.hasAdvertisingPlan
  },
  getServiceAreaCoords (state, getters) {
    return state.serviceAreaCoords
  },
  getBlockList (state, getters) {
    return state.blockList
  },
  getBaseUrl (state, getters, rootState, rootGetters) {
    var baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xsmall/'
    if (rootGetters['user/getUserType'] === 'business') {
      baseURL = baseURL + getters.getBusinessId
    } else if (rootGetters['user/getUserType'] === 'user') {
      if (rootGetters.cognitoId) {
        baseURL = baseURL + rootGetters.cognitoId.split(':')[1]
      }
    }
    return baseURL
  },
  getImageUrls (state, getters, rootGetters) {
    var imageURLS = []
    for (var image in state.images) {
      var imageURL = getters.getBaseUrl + '/' + state.images[image]
      imageURLS.push(imageURL)
    }
    return imageURLS
  },
  getProfileImageUrl (state, getters) {
    return getters.getBaseUrl + '/' + getters.getProfileImage
  },
  getBannerImageUrl (state, getters) {
    return getters.getBaseUrl + '/' + getters.getBannerImage
  },
  getBusinessId: (state) => {
    return state.businessId
  },
  profileIsComplete: (state) => {
    var returnObject = {
      profileComplete: true,
      incompletePath: null
    }

    if (!state.businessName ||
        // !state.ssn ||
        !state.address ||
        !state.city ||
        !state.state ||
        !state.zip ||
        !state.salesPhoneNumber ||
        !state.salesEmail ||
        !state.serviceType ||
        !state.website) {
      returnObject.profileComplete = false
      returnObject.incompletePath = '/profile/business/details/overview'
      return returnObject
    }

    if (!state.costLevel ||
        !state.availabilityLevel ||
        !state.emergencies ||
        (state.selectedServices.length === 0) ||
        !state.areasServiced) {
      returnObject.profileComplete = false
      returnObject.incompletePath = '/profile/business/details/services'
      return returnObject
    }

    if (!state.profileImage ||
        !state.bannerImage) {
      returnObject.profileComplete = false
      returnObject.incompletePath = '/profile/business/details/pictures'
      return returnObject
    }

    if (!state.companyInfo) {
      returnObject.profileComplete = false
      returnObject.incompletePath = '/profile/business/details/about'
      return returnObject
    }

    if (!state.adminFirstName ||
        !state.adminLastName ||
        !state.adminEmail ||
        !state.adminPhone) {
      returnObject.profileComplete = false
      returnObject.incompletePath = '/profile/business/contacts'
      return returnObject
    }
    return returnObject
  },
  getSpecialties: (state) => {
    return state.specialties
  },
  getEmail: (state) => {
    return state.email
  },
  getMFAStatus: (state) => {
    return state.MFA
  },
  getPhoneNumber: (state) => {
    return state.phoneNumber
  },
  getBusinessName: (state) => {
    return state.businessName
  },
  getAddress: (state) => {
    return state.address
  },
  getAddressTwo: (state) => {
    return state.addressTwo
  },
  getCity: (state) => {
    return state.city
  },
  getState: (state) => {
    return state.state
  },
  getZip: (state) => {
    return state.zip
  },
  getBusinessPhone: (state) => {
    return state.businessPhone
  },
  getInsuranceAmount: (state) => {
    return state.insuranceAmount
  },
  getWebsite: (state) => {
    return state.website
  },
  getCompanyInfo: (state) => {
    return state.companyInfo
  },
  getCompanyInfoTwo: (state) => {
    return state.companyInfoTwo
  },
  getAreasServiced: (state) => {
    return state.areasServiced
  },
  getAlteredForms: (state) => {
    return state.alteredForms
  },
  getAdminFirstName: (state) => {
    return state.adminFirstName
  },
  getAdminLastName: (state) => {
    return state.adminLastName
  },
  getAdminEmail: (state) => {
    return state.adminEmail
  },
  getAdminPhone: (state) => {
    return state.adminPhone
  },
  adminComplete: (state) => {
    if (state.adminFirstName && state.adminLastName && state.adminEmail && state.adminPhone) {
      return true
    } else {
      return false
    }
  },
  getQcFirstName: (state) => {
    return state.qcFirstName
  },
  getQcLastName: (state) => {
    return state.qcLastName
  },
  getQcEmail: (state) => {
    return state.qcEmail
  },
  getQcPhone: (state) => {
    return state.qcPhone
  },
  getCsFirstName: (state) => {
    return state.csFirstName
  },
  getCsLastName: (state) => {
    return state.csLastName
  },
  getCsEmail: (state) => {
    return state.csEmail
  },
  getCsPhone: (state) => {
    return state.csPhone
  },
  getSalesEmail: (state) => {
    return state.salesEmail
  },
  getDisplayName: (state) => {
    return state.displayName
  },
  getSalesPhoneNumber: (state) => {
    return state.salesPhoneNumber
  },
  getLicenseNumber: (state) => {
    return state.licenseNumber
  },
  getCostLevel: (state) => {
    return state.costLevel
  },
  getAvailabilityLevel: (state) => {
    return state.availabilityLevel
  },
  getTimes: (state) => {
    return state.times
  },
  getEmergencies: (state) => {
    return state.emergencies
  },
  getSelectedServices: (state) => {
    return state.selectedServices
  },
  getImages: (state) => {
    return state.images
  },
  getProfileImage: (state) => {
    return state.profileImage
  },
  hasBillingContact: (state) => {
    if (state.qcFirstName || state.qcLastName || state.qcEmail || state.qcPhone) {
      return true
    } else {
      return false
    }
  },
  hasCustomerServiceContact: (state) => {
    if (state.csFirstName || state.csLastName || state.csEmail || state.csPhone) {
      return true
    } else {
      return false
    }
  },
  getBannerImage: (state) => {
    return state.bannerImage
  },
  getSSN: (state) => {
    return state.ssn
  },
  getServiceType: (state) => {
    return state.serviceType
  },
  getYearEstablished: (state) => {
    return state.yearEstablished
  },
  getLanguagesSpoken: (state) => {
    return state.languagesSpoken
  },
  getHideAddress: (state) => {
    return state.hideAddress
  },
  getAllowSendTexts: (state) => {
    return state.allowSendTexts
  },
  getEnableQuoteRequest: (state) => {
    return state.enableQuoteRequest
  },
  getHideYears: (state) => {
    return state.hideYears
  },
  getCouponPaymentOverdue: (state) => {
    return state.couponPaymentOverdue
  },
  getPaymentFailureNotification: (state) => {
    return state.paymentFailureNotification
  }
}

const mutations = {
  updateServiceAreaCoords: (state, coords) => {
    state.serviceAreaCoords = coords
  },
  addToBlockList: (state, id) => {
    if (!state.blockList.includes(id)) {
      state.blockList.push(id)
    }
  },
  removeFromBlockList: (state, id) => {
    var index = state.blockList.indexOf(id)
    if (index > -1) {
      state.blockList.splice(index, 1)
    }
  },
  updateBlockList (state, blockList) {
    state.blockList = blockList
  },
  updateBusinessId (state, businessId) {
    state.businessId = businessId
  },
  updateEmail (state, email) {
    state.email = email
  },
  updateMFA (state, MFA) {
    state.MFA = MFA
  },
  updatePhoneNumber (state, phoneNumber) {
    state.phoneNumber = phoneNumber
  },
  updateBusinessName: (state, businessName) => {
    state.businessName = businessName
  },
  updateAddress: (state, address) => {
    state.address = address
  },
  updateAddressTwo: (state, addressTwo) => {
    state.addressTwo = addressTwo
  },
  updateCity: (state, city) => {
    state.city = city
  },
  updateState: (state, usState) => {
    state.state = usState
  },
  updateZip: (state, zip) => {
    state.zip = zip
  },
  updateBusinessPhone: (state, businessPhone) => {
    state.businessPhone = businessPhone
  },
  updateWebsite: (state, website) => {
    state.website = website
  },
  updateCompanyInfo: (state, companyInfo) => {
    state.companyInfo = companyInfo
  },
  updateCompanyInfoTwo: (state, companyInfoTwo) => {
    state.companyInfoTwo = companyInfoTwo
  },
  updateAreasServiced: (state, areasServiced) => {
    state.areasServiced = areasServiced
  },
  addArea (state, area) {
    state.areasServiced.push(area)
  },
  removeArea (state, index) {
    state.areasServiced.splice(index, 1)
  },
  clearAreas (state) {
    state.areasServiced = []
  },
  addAlteredForm: (state, alteredForm) => {
    if (!state.alteredForms.includes(alteredForm)) {
      state.alteredForms.push(alteredForm)
    }
  },
  removeAlteredForm: (state, alteredForm) => {
    var index = state.alteredForms.indexOf(alteredForm)
    if (index > -1) {
      state.alteredForms.splice(index, 1)
    }
  },
  updateAlteredForms: (state, alteredForms) => {
    state.alteredForms = alteredForms
  },
  updateAdminFirstName: (state, adminFirstName) => {
    state.adminFirstName = adminFirstName
  },
  updateAdminLastName: (state, adminLastName) => {
    state.adminLastName = adminLastName
  },
  updateAdminEmail: (state, adminEmail) => {
    state.adminEmail = adminEmail
  },
  updateAdminPhone: (state, adminPhone) => {
    state.adminPhone = adminPhone
  },
  updateQcFirstName: (state, qcFirstName) => {
    state.qcFirstName = qcFirstName
  },
  updateQcLastName: (state, qcLastName) => {
    state.qcLastName = qcLastName
  },
  updateQcEmail: (state, qcEmail) => {
    state.qcEmail = qcEmail
  },
  updateQcPhone: (state, qcPhone) => {
    state.qcPhone = qcPhone
  },
  updateCsFirstName: (state, csFirstName) => {
    state.csFirstName = csFirstName
  },
  updateCsLastName: (state, csLastName) => {
    state.csLastName = csLastName
  },
  updateCsEmail: (state, csEmail) => {
    state.csEmail = csEmail
  },
  updateCsPhone: (state, csPhone) => {
    state.csPhone = csPhone
  },
  updateSalesEmail: (state, salesEmail) => {
    state.salesEmail = salesEmail
  },
  updateDisplayName: (state, displayName) => {
    state.displayName = displayName
  },
  updateSalesPhoneNumber: (state, salesPhoneNumber) => {
    state.salesPhoneNumber = salesPhoneNumber
  },
  updateInsuranceAmount: (state, insuranceAmount) => {
    state.insuranceAmount = Number(insuranceAmount)
  },
  updateLicenseNumber: (state, licenseNumber) => {
    state.licenseNumber = licenseNumber
  },
  updateCostLevel: (state, costLevel) => {
    state.costLevel = Number(costLevel)
  },
  updateAvailabilityLevel: (state, availabilityLevel) => {
    state.availabilityLevel = Number(availabilityLevel)
  },
  updateTimes: (state, times) => {
    for (var key in times) {
      state.times[key] = {...state.times[key], ...times[key]}
    }
  },
  updateEmergencies: (state, emergencies) => {
    state.emergencies = emergencies
  },
  updateSelectedServices: (state, selectedServices) => {
    state.selectedServices = selectedServices
  },
  updateImages: (state, images) => {
    state.images = images
  },
  removeImage: (state, image) => {
    var index = state.images.indexOf(image)
    var profileIndex = state.images.indexOf(state.profileImage)
    var bannerIndex = state.images.indexOf(state.bannerImage)
    if (index > -1) {
      state.images.splice(index, 1)
    }
    if (profileIndex === index) {
      state.profileImage = null
    }
    if (bannerIndex === index) {
      state.bannerImage = null
    }
  },
  updateProfileImage: (state, profileImage) => {
    state.profileImage = profileImage
  },
  updateBannerImage: (state, bannerImage) => {
    state.bannerImage = bannerImage
  },
  updateSSN: (state, ssn) => {
    state.ssn = ssn
  },
  updateServiceType: (state, serviceType) => {
    state.serviceType = serviceType
  },
  updateSpecialties: (state, specialties) => {
    state.specialties = specialties
  },
  updateYearEstablished: (state, yearEstablished) => {
    state.yearEstablished = yearEstablished
  },
  updateLanguagesSpoken: (state, languagesSpoken) => {
    state.languagesSpoken = languagesSpoken
  },
  updateHideAddress: (state, hideAddress) => {
    state.hideAddress = hideAddress
  },
  updateAllowSendTexts: (state, allowSendTexts) => {
    state.allowSendTexts = allowSendTexts
  },
  updateEnableQuoteRequest: (state, enableQuoteRequest) => {
    state.enableQuoteRequest = enableQuoteRequest
  },
  updateHideYears: (state, hideYears) => {
    state.hideYears = hideYears
  },
  updateCouponPaymentOverdue: (state, couponPaymentOverdue) => {
    state.couponPaymentOverdue = couponPaymentOverdue
  },
  updatePaymentFailureNotification: (state, paymentFailureNotification) => {
    state.paymentFailureNotification = paymentFailureNotification
  },
  updateHasAdvertisingPlan: (state, hasAdvertisingPlan) => {
    state.hasAdvertisingPlan = hasAdvertisingPlan
  }
}

const actions = {
  deleteBusinessData ({ commit }) {
    commit('updateEmail', defaultValues.email)
    commit('updatePhoneNumber', defaultValues.phoneNumber)
    commit('updateMFA', defaultValues.MFA)
    commit('updateBusinessName', defaultValues.businessName)
    commit('updateAddress', defaultValues.address)
    commit('updateAddressTwo', defaultValues.addressTwo)
    commit('updateCity', defaultValues.city)
    commit('updateState', defaultValues.state)
    commit('updateZip', defaultValues.zip)
    commit('updateBusinessPhone', defaultValues.businessPhone)
    commit('updateWebsite', defaultValues.website)
    commit('updateCompanyInfo', defaultValues.companyInfo)
    commit('updateCompanyInfoTwo', defaultValues.companyInfoTwo)
    commit('updateAreasServiced', JSON.parse(JSON.stringify(defaultValues.areasServiced)))
    commit('updateAlteredForms', JSON.parse(JSON.stringify(defaultValues.alteredForms)))
    commit('updateAdminEmail', defaultValues.adminEmail)
    commit('updateAdminFirstName', defaultValues.adminFirstName)
    commit('updateAdminLastName', defaultValues.adminLastName)
    commit('updateAdminPhone', defaultValues.adminPhone)
    commit('updateCsEmail', defaultValues.csEmail)
    commit('updateCsFirstName', defaultValues.csFirstName)
    commit('updateCsLastName', defaultValues.csLastName)
    commit('updateCsPhone', defaultValues.csPhone)
    commit('updateQcEmail', defaultValues.qcEmail)
    commit('updateQcFirstName', defaultValues.qcFirstName)
    commit('updateQcLastName', defaultValues.qcLastName)
    commit('updateQcPhone', defaultValues.qcPhone)
    commit('updateSalesEmail', defaultValues.salesEmail)
    commit('updateDisplayName', defaultValues.displayName)
    commit('updateSalesPhoneNumber', defaultValues.salesPhoneNumber)
    commit('updateInsuranceAmount', defaultValues.insuranceAmount)
    commit('updateLicenseNumber', defaultValues.licenseNumber)
    commit('updateCostLevel', defaultValues.costLevel)
    commit('updateAvailabilityLevel', defaultValues.availabilityLevel)
    commit('updateTimes', JSON.parse(JSON.stringify(defaultValues.times)))
    commit('updateEmergencies', defaultValues.emergencies)
    commit('updateSelectedServices', JSON.parse(JSON.stringify(defaultValues.selectedServices)))
    commit('updateImages', defaultValues.images)
    commit('updateProfileImage', defaultValues.profileImage)
    commit('updateBannerImage', defaultValues.bannerImage)
    commit('updateSSN', defaultValues.ssn)
    commit('updateServiceType', defaultValues.serviceType)
    commit('updateYearEstablished', defaultValues.yearEstablished)
    commit('updateLanguagesSpoken', defaultValues.languagesSpoken)
    commit('updateHideAddress', defaultValues.hideAddress)
    commit('updateAllowSendTexts', defaultValues.allowSendTexts)
    commit('updateEnableQuoteRequest', defaultValues.enableQuoteRequest)
    commit('updateHideYears', defaultValues.hideYears)
    commit('updateBusinessId', defaultValues.businessId)
    commit('updateBlockList', defaultValues.blockList)
    commit('updateServiceAreaCoords', JSON.parse(JSON.stringify(defaultValues.serviceAreaCoords)))
    commit('updateCouponPaymentOverdue', defaultValues.couponPaymentOverdue)
    commit('updatePaymentFailureNotification', defaultValues.paymentFailureNotification)
    commit('updateSpecialties', JSON.parse(JSON.stringify(defaultValues.specialties)))
    commit('updateHasAdvertisingPlan', defaultValues.hasAdvertisingPlan)
  },
  async getUserAttributes ({ commit, state, rootState, rootGetters, dispatch }) {
    try {
      AWS.config.update({
        credentials: new AWS.Credentials(rootGetters.getAccessKeyId, rootGetters.getSecretAccessKey, rootGetters.getSessionToken),
        region: window.CONFIG.Region
      })
      await dispatch('user/getCurrentUserData', null, {root: true})
      if (rootState.user.userType === 'business') {
        await dispatch('getCurrentBusinessData')
      }
      if (rootState.user.userType === 'realtor') {
        await dispatch('realtor/getCurrentRealtorData', rootState.user.myRealtorCode, {root: true})
      }
      if (rootState.user.userType === 'service provider') {
        await dispatch('serviceProvider/getCurrentServiceProviderData', rootState.user.myServiceProviderId, {root: true})
      }
    } catch (error) {
      console.log(error)
    }
    if (rootGetters.getIdProvider === 'cognito') {
      var result = await HomAptCognito.getUserAttributes()
      for (var i = 0; i < result.length; i++) {
        // If phone number is not null then it means the user is using MFA
        if ((result[i].getName() === 'phone_number') && (result[i].getValue() !== null)) {
          commit('updatePhoneNumber', result[i].getValue())
          commit('updateMFA', true)
        }
        if ((result[i].getName() === 'email') && (result[i].getValue() !== null)) {
          commit('updateEmail', result[i].getValue())
        }
      }
    }
  },
  async setPhoneNumber ({ commit, state, getters }) {
    return HomAptCognito.updatePhoneNumber(getters.getPhoneNumber)
  },
  async toggleMFA ({ commit, state, dispatch }, MFAStatus) {
    var result
    if (MFAStatus === true) {
      await dispatch('setPhoneNumber')
      result = await HomAptCognito.enableMFA()
      commit('updateMFA', MFAStatus)
      return result
    } else {
      commit('updatePhoneNumber', defaultValues.phoneNumber)
      await dispatch('setPhoneNumber')
      result = await HomAptCognito.disableMFA()
      commit('updateMFA', MFAStatus)
      return result
    }
  },
  // This creates entries in the user table
  async createUser ({ commit, state, rootGetters }) {
    var client = rootGetters.getUserApigClientFactory
    var params = {}
    var userPath = '/users'
    var method = 'POST'
    var additionalParams = {}
    var body = {}
    try {
      await client.invokeApi(params, userPath, method, additionalParams, body)
    } catch (error) {
      if (error.response.data !== 'User already exists.') {
        console.log(error.response)
      }
    }
  },
  // This creates entries in the business-registration table
  async createBusiness ({ commit, state, rootGetters }, googleId) {
    var client = rootGetters.getBusinessApigClientFactory
    var params = {}
    var businessPath = '/businesses'
    var method = 'POST'
    var additionalParams = {}
    var body = {}
    if (googleId) {
      body = { 'google_id': googleId }
    }
    try {
      await client.invokeApi(params, businessPath, method, additionalParams, body)
    } catch (error) {
      if (error.response.data !== 'Business already exists.') {
        console.log(error.response)
        throw error
      }
    }
  },
  async getBtToken ({ commit, state, rootGetters }) {
    var client = rootGetters.getPaymentApigClientFactory
    var params = {}
    var pathTemplate = '/businesses/bt-token'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getCurrentBusinessData ({ commit, dispatch, state, rootGetters }) {
    var client = rootGetters.getBusinessApigClientFactory
    var params = {
      id: 'self'
    }
    var pathTemplate = '/businesses/{id}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var business = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      var businessData = business.data
      if ('about_us' in businessData) commit('updateCompanyInfo', businessData.about_us)
      if ('about_us_two' in businessData) commit('updateCompanyInfoTwo', businessData.about_us_two)
      if ('address1' in businessData) commit('updateAddress', businessData.address1)
      if ('address2' in businessData) commit('updateAddressTwo', businessData.address2)
      if ('admin_email' in businessData) commit('updateAdminEmail', businessData.admin_email)
      if ('admin_first_name' in businessData) commit('updateAdminFirstName', businessData.admin_first_name)
      if ('admin_last_name' in businessData) commit('updateAdminLastName', businessData.admin_last_name)
      if ('admin_phone' in businessData) commit('updateAdminPhone', businessData.admin_phone)
      if ('business_name' in businessData) commit('updateBusinessName', businessData.business_name)
      if ('city' in businessData) commit('updateCity', businessData.city)
      if ('cs_email' in businessData) commit('updateCsEmail', businessData.cs_email)
      if ('cs_first_name' in businessData) commit('updateCsFirstName', businessData.cs_first_name)
      if ('cs_last_name' in businessData) commit('updateCsLastName', businessData.cs_last_name)
      if ('cs_phone' in businessData) commit('updateCsPhone', businessData.cs_phone)
      if ('display_name' in businessData) commit('updateDisplayName', businessData.display_name)
      if ('qc_email' in businessData) commit('updateQcEmail', businessData.qc_email)
      if ('qc_first_name' in businessData) commit('updateQcFirstName', businessData.qc_first_name)
      if ('qc_last_name' in businessData) commit('updateQcLastName', businessData.qc_last_name)
      if ('qc_phone' in businessData) commit('updateQcPhone', businessData.qc_phone)
      if ('state' in businessData) commit('updateState', businessData.state)
      if ('website' in businessData) commit('updateWebsite', businessData.website)
      if ('sales_phone' in businessData) commit('updateSalesPhoneNumber', businessData.sales_phone)
      if ('sales_email' in businessData) commit('updateSalesEmail', businessData.sales_email)
      if ('license_number' in businessData) commit('updateLicenseNumber', businessData.license_number)
      if ('insured_amount' in businessData) commit('updateInsuranceAmount', businessData.insured_amount)
      if ('cost_level' in businessData) commit('updateCostLevel', businessData.cost_level)
      if ('availability_level' in businessData) commit('updateAvailabilityLevel', businessData.availability_level)
      if ('hours' in businessData) commit('updateTimes', JSON.parse(businessData.hours))
      if ('zip_code' in businessData) commit('updateZip', businessData.zip_code)
      if ('emergencies' in businessData) commit('updateEmergencies', businessData.emergencies)
      if ('categories' in businessData) commit('updateSelectedServices', businessData.categories)
      if ('images' in businessData) commit('updateImages', businessData.images)
      if ('profile_image' in businessData) commit('updateProfileImage', businessData.profile_image)
      if ('banner_image' in businessData) commit('updateBannerImage', businessData.banner_image)
      if ('ssn' in businessData) commit('updateSSN', businessData.ssn)
      if ('service_type' in businessData) commit('updateServiceType', JSON.parse(businessData.service_type))
      if ('year_established' in businessData) commit('updateYearEstablished', businessData.year_established)
      if ('languages_spoken' in businessData) commit('updateLanguagesSpoken', businessData.languages_spoken)
      if ('service_area' in businessData) commit('updateAreasServiced', businessData.service_area)
      if ('hide_address' in businessData) commit('updateHideAddress', businessData.hide_address)
      if ('allow_send_texts' in businessData) commit('updateAllowSendTexts', businessData.allow_send_texts)
      if ('enable_quote_request' in businessData) commit('updateEnableQuoteRequest', businessData.enable_quote_request)
      if ('hide_years' in businessData) commit('updateHideYears', businessData.hide_years)
      if ('business_id' in businessData) commit('updateBusinessId', businessData.business_id)
      if ('block_list' in businessData) commit('updateBlockList', businessData.block_list)
      if ('service_area_coords' in businessData) commit('updateServiceAreaCoords', businessData.service_area_coords)
      if ('specialties' in businessData) commit('updateSpecialties', businessData.specialties)
      if ('has_advertising_plan' in businessData) commit('updateHasAdvertisingPlan', businessData.has_advertising_plan)
      if ('coupon_payment_overdue' in businessData) {
        commit('updateCouponPaymentOverdue', businessData.coupon_payment_overdue)
        await dispatch('getPaymentNotifications')
      } else {
        commit('updateCouponPaymentOverdue', defaultValues.couponPaymentOverdue)
        commit('updatePaymentFailureNotification', defaultValues.paymentFailureNotification)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async syncData ({ commit, state, dispatch, rootGetters }) {
    try {
      if (rootGetters['user/getUserType'] === 'business') await dispatch('putBusinessData')
      await dispatch('user/putUserData', null, {root: true})
    } catch (error) {
      console.log(error)
    }
  },
  async putBusinessData ({ commit, state, rootGetters }) {
    var client = rootGetters.getBusinessApigClientFactory
    var params = {}
    var pathTemplate = '/businesses'
    var method = 'PUT'
    var additionalParams = {}
    var body = {
      'business_name': state.businessName,
      'address1': state.address,
      'address2': state.addressTwo,
      'city': state.city,
      'state': state.state,
      'phone': state.phone,
      'website': state.website,
      'about_us': state.companyInfo,
      'about_us_two': state.companyInfoTwo,
      'admin_first_name': state.adminFirstName,
      'admin_last_name': state.adminLastName,
      'admin_email': state.adminEmail,
      'admin_phone': state.adminPhone,
      'qc_first_name': state.qcFirstName,
      'qc_last_name': state.qcLastName,
      'qc_email': state.qcEmail,
      'qc_phone': state.qcPhone,
      'cs_first_name': state.csFirstName,
      'cs_last_name': state.csLastName,
      'cs_email': state.csEmail,
      'cs_phone': state.csPhone,
      'display_name': state.displayName,
      'sales_email': state.salesEmail,
      'sales_phone': state.salesPhoneNumber,
      'license_number': state.licenseNumber,
      'insured_amount': state.insuranceAmount,
      'cost_level': state.costLevel,
      'availability_level': state.availabilityLevel,
      'hours': JSON.stringify(state.times),
      'zip_code': state.zip,
      'emergencies': state.emergencies,
      'categories': state.selectedServices,
      'images': state.images,
      'profile_image': state.profileImage,
      'banner_image': state.bannerImage,
      'ssn': state.ssn,
      'service_type': JSON.stringify(state.serviceType),
      'year_established': state.yearEstablished,
      'languages_spoken': state.languagesSpoken,
      'service_area': state.areasServiced,
      'hide_address': state.hideAddress,
      'allow_send_texts': state.allowSendTexts,
      'enable_quote_request': state.enableQuoteRequest,
      'hide_years': state.hideYears,
      'block_list': state.blockList,
      'service_area_coords': state.serviceAreaCoords,
      'specialties': state.specialties
    }
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  },
  async getPaymentNotifications ({ commit, state, rootGetters }) {
    var client = rootGetters.getNotificationApigClientFactory
    var params = {}
    var pathTemplate = '/notifications'
    var method = 'GET'
    var additionalParams = {
      queryParams: {
        limit: 25
      }
    }
    additionalParams.queryParams['requesting_as'] = rootGetters['business/getBusinessId']
    var body = {}
    try {
      var notificationData = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      var newRecord = false
      if (notificationData.data.data.length > 0) {
        for (var record of notificationData.data.data) {
          if (record.category === 'Payment Failure') {
            newRecord = true
            commit('updatePaymentFailureNotification', record.data)
          }
        }
      }
      // Reset payment notification if no current notification
      if (!newRecord) {
        commit('updatePaymentFailureNotification', defaultValues.paymentFailureNotification)
      }
    } catch (error) {
      console.log(error)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/business.js